define('apps/admin/views/modals/reset_password',[
        'app',
        'njs!apps/admin/templates/includes/modals/_reset_password(params:tmpl=admin/main/includes/modals/_reset_password.html)',
        'apps/admin/views/strong-validation',
        'apps/admin/views/validation-message',
        'apps/admin/views/modals/blank-modal',
    ], function(app, template, StrongValidation, ValidationMessage, BlankModal) {
        'use strict';

        return Mn.ItemView.extend({
            "resetPasswordXHR": null,
            "validatePasswordXHR": null,
            "strongValidationConfig": {
                'doesnt_have_min_characters': true,
                'contains_username': true,
                'contains_first_name': true,
                'contains_last_name': true,
                'contains_repeat_characters': true,
                'missing_upper_lower': true,
                'contains_common_passwords': true,
            },
            "events": {
                "click .nebula-modal__button--cancel": "closeModal",
                "click .comet-modal-overlay--backdrop": "closeModal",
                "click #reset-password": "onClickResetPassword",
                "keyup .admin-form--reset-password #password": "onPasswordKeyup"
            },

            "template": template,

            "onRender": function() {
                if (this.model.get('requireStrongPassword')) {
                    this.strongValidationView = new StrongValidation({
                        'model': new Backbone.Model({
                            'target': 'admin-form__strong-validation',
                            'validationConfig': this.strongValidationConfig,
                            'is_valid': false
                        })
                    });

                    this.$('.admin-form__strong-validation').append(this.strongValidationView.render().$el);
                }
            },

            "modelEvents": {
                "change": "render"
            },

            "validateInput": function(formInput){
                this.$(formInput).removeClass('invalid');
            },

            "invalidateInput": function(formInput){
                this.$(formInput).addClass('invalid');
            },

            "addCometFormError": function(formInput){
                this.$(formInput).closest('.comet-form__field-group').addClass('comet-form--error');
            },

            "removeCometFormError": function(formInput){
                this.$(formInput).closest('.comet-form__field-group').removeClass('comet-form--error');
            },

            "appendValidationMessage": function(target, messageType, messageText) {
                var validationMessage = "validationMessage" + target;

                // destroy previous validation messages
                if (this[validationMessage]) {
                    this[validationMessage].destroy();
                }

                this[validationMessage] = new ValidationMessage({
                    'model': new Backbone.Model({
                        'target': target.substring(1),
                        'messageType': messageType,
                        'messageText': messageText
                    })
                });

                this.$(target).closest('.comet-form__field-group').append(this[validationMessage].render().$el);
            },

            "validatePasswordConfirm": function() {
                this.invalidateInput('#password-confirm');
                this.removeCometFormError('#password-confirm');

                var password = this.$('.admin-form--reset-password #password').val(),
                    passwordConfirm = this.$('.admin-form--reset-password #password-confirm').val();

                if (!passwordConfirm) {
                    if (this['validationMessage#password-confirm']){
                        this['validationMessage#password-confirm'].destroy();
                    }
                } else {
                    if (password === passwordConfirm) {
                        this.appendValidationMessage('#password-confirm', 'valid', 'Passwords match');
                        this.removeCometFormError('#password-confirm');
                        this.validateInput('#password-confirm');
                    } else {
                        this.appendValidationMessage('#password-confirm', 'invalid', 'Passwords do not match');
                        this.addCometFormError('#password-confirm');
                        this.invalidateInput('#password-confirm');
                    }
                }
            },

            "onPasswordKeyup": _.debounce(function() {
                this.invalidateInput('#password');
                this.removeCometFormError('#password');

                if (this['validationMessage#password']){
                    this['validationMessage#password'].destroy();
                };

                var passwordConfirmValueExists = this.$('#password-confirm').val();
                var passwordConfirmInErrorState = this.$('#password-confirm').closest('.comet-form__field-group').hasClass('comet-form--error');

                if (passwordConfirmValueExists || passwordConfirmInErrorState) {
                    this.validatePasswordConfirm();
                }

                var password = this.$('#password').val().trim();

                if (!password) {
                    if (this.validatePasswordXHR) {
                        this.validatePasswordXHR.abort();
                    }

                    if (this['validationMessage#password']){
                        this['validationMessage#password'].destroy();
                    }
                } else {
                    this.validatePassword(password);
                }
            }, 500),

            "validatePassword": function(password) {
                this.appendValidationMessage('#password', 'waiting', 'Checking password');

                var requestData = {
                    "username": this.model.get('username'),
                    "user_id": this.model.get('userGuid'),
                    "password": password,
                };

                var requestSettings = {
                    'context': this,
                    "url": "/apiproxy/v1/users/valid_password",
                    "method": "POST",
                    "data": requestData,
                    "beforeSend": _.bind(function(){
                        // cancel previous request before starting new request
                        if (this.validatePasswordXHR !== null && this.validatePasswordXHR.readystate !== 4) {
                            this.validatePasswordXHR.abort();
                        }
                    }, this),
                };

                this.validatePasswordXHR = $.ajax(requestSettings)
                    .done(function(data, textStatus, jqXHR) {
                        if (this["validationMessage#password"]) {
                            this["validationMessage#password"].destroy();
                        }

                        if (this.model.get('requireStrongPassword')) {
                            this.strongValidationView.model.set('validationConfig', data.validation_results);
                            this.strongValidationView.model.set('is_valid', data.is_valid);

                            $('.admin-form__strong-validation').append(this.strongValidationView.render().$el);
                        }

                        if (data.is_valid) {
                            this.removeCometFormError('#password');
                            this.validateInput('#password');
                            this.appendValidationMessage('#password', 'valid', data.message);
                        } else {
                            this.addCometFormError('#password');
                            this.invalidateInput('#password');

                            if (!this.model.get('requireStrongPassword')) {
                                this.appendValidationMessage('#password', 'invalid', data.message);
                            }
                        }
                    })
                    .fail(function(jqxhr, textStatus, error) {
                        var err = textStatus + ", " + error;
                        window.console.log("Request Failed: " + err);
                    });
            },

            "onClickResetPassword": function(e) {
                e.preventDefault();

                var params = {
                    'token': this.model.get('token'),
                    "userguid": this.model.get('userGuid'),
                    "password": this.$('#password').val(),
                    "password_confirm": this.$('#password_confirm').val()
                };

                var requestSettings = {
                    "url": "/apiproxy/v1/users/reset-password",
                    "method": "POST",
                    "data": params,
                    "xhrFields": {
                        "withCredentials": true
                    },
                    "beforeSend": _.bind(function(){
                        // cancel previous request before starting new request
                        if (this.resetPasswordXHR !== null && this.resetPasswordXHR.readystate !== 4) {
                            this.resetPasswordXHR.abort();
                        }
                    }, this),
                };

                this.resetPasswordXHR = $.ajax(requestSettings)
                    .done(_.bind(function(data, textStatus, jqXHR) {
                        if (data.meta.valid) {
                            if ('is_valid' in data && data.is_valid === false) {
                                this.model.set({
                                    'errorMessage': data.message,
                                });
                                return;
                            }

                            this.destroy();
                            this.modal = new BlankModal({
                                'model': new Backbone.Model({
                                    'modalHeader': 'Password was reset successfully',
                                    'showOKButton': true
                                })
                            });

                            $('body').append(this.modal.render().$el);
                        }
                    }, this))
                    .fail(_.bind(function(jqxhr, textStatus, error) {
                        var err = textStatus + ", " + error;
                        window.console.log("Request Failed: " + err);

                        var response = JSON.parse(jqxhr.responseText);
                        var responseMessage = response.meta.message;
                        this.model.set({'errorMessage': responseMessage });
                    }, this));
            },

            "closeModal": function(event) {
                this.destroy();
            },

        });

});

